import React from "react"
import '../../node_modules/bootstrap/dist/css/bootstrap.min.css';
import { Container } from "react-bootstrap"
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import '../../node_modules/bootstrap/dist/css/bootstrap.min.css';
import { Layout } from "../common/Layout"
import { WhiteLayout } from "../common/Layout1";
import Map from "./Map";
import WhiteMap from "./WhiteMap";
import Login from "./Auth/login"
import AdminDashboard from "./Admin/index";
import PrivateRoute from './PrivateRoute';

function App() {
  return (
    <Container
      fluid={true}
      className="d-flex justify-content-center p-0"
      style={{ minHeight: "100vh" }}
    >
      <div className="w-100" style={{ overflow: "hidden", background: "#fffff" }}>
        <Router>
          <Routes>
            <Route exact path="/" element={<WhiteLayout><WhiteMap /></WhiteLayout>} />
            <Route path="/white" element={<WhiteLayout><WhiteMap /></WhiteLayout>} />
            <Route path="/login" element={<Login />} />
            <Route exact path='/dashboard' element={<PrivateRoute/>}>
              <Route exact path='/dashboard' element={<WhiteLayout><AdminDashboard /></WhiteLayout>}/>
            </Route>
          </Routes>
        </Router>
      </div>
    </Container>
  )
}

export default App;
